import { useEffect } from "react";
import { useState } from "react";
import { useAuth } from "../context/auth-context";
import { useUser } from "../context/user-context";
import { Navigate } from "react-router-dom";
import { Loading } from "../components/Loading";

export const SuperManagerRoute = ({ children }: { children: React.ReactNode }) => {
    const { token } = useAuth();
    const { user, isLoading } = useUser();
    
    useEffect(() => {
      if (!isLoading && user) {
        // El usuario ya está cargado desde el contexto
      }
    }, [user, isLoading]);
  
    if (isLoading) {
      return <Loading />;
    }
  
    const isSuperManager = user?.rol === "Manager" && user?.isResponsible;
    
    if (!isSuperManager) {
      return <Navigate to="/dashboard" replace />;
    }
  
    return <>{children}</>;
  };
  